<template>
  <div id="app" v-if="system">
    <v-alert type="error" v-if="!userIsOwner && !system.locked">
      Systemet är inte låst, och kan därmed bara ses av dess skapare.
    </v-alert>
    <div v-if="system && (userIsOwner || system.locked)">
      <v-navigation-drawer v-model="drawer" app width=350 v-if="userIsOwner">
        <SystemSettings
          v-if="system"
          :system="this.system"
          @changeSorting="changeSorting"
        />

      </v-navigation-drawer>
      <v-app-bar app color="indigo" dark>
        <v-btn icon @click.stop="drawer = !drawer" v-if="userIsOwner">
          <v-icon>mdi-file-cog</v-icon>
        </v-btn>
        <div class="d-none d-md-flex">
          <div class="nav-value-box">
            <span class="nav-value-box__title">Systemstorlek</span><br/>
            <span class="nav-value-box__value">
              {{system.reduction_result.SystemSize}} rader
            </span>
            <span class="nav-value-box__value" v-if="$store.state.systems.status"></span>
          </div>
          <div class="nav-value-box">
            <span class="nav-value-box__title">Reducerad storlek</span><br/>
            <span class="nav-value-box__value">{{system.reduction_result.ReducedSize}} rader({{system.reduction_result.ReductionPercentage | toPercent}}%)</span>
          </div>
          <div class="nav-value-box">
            <span class="nav-value-box__title">Kostnad</span><br/>
            <span class="nav-value-box__value">{{system.reduction_result.SystemCost}}:-</span>
          </div>
          <div class="nav-value-box">
            <span class="nav-value-box__title">Potentiell utdelning</span><br/>
            <span class="nav-value-box__value" v-if="system.reduction_result.MinRowValue">{{system.reduction_result.MinRowValue | numberSpacing}}:- <span style="font-size:12px;color:#ccc">till</span> {{system.reduction_result.MaxRowValue | numberSpacing}}:-</span>
          </div>
        </div>
        <div class="d-flex d-md-none">
          {{system.reduction_result.ReducedSize}} rader (- {{system.reduction_result.ReductionPercentage | toPercent}}%)
          <br/>
          {{system.reduction_result.SystemCost}}:-
        </div>
        <v-icon v-if="system.locked" title="Systemet är låst!">mdi-lock</v-icon>
        <v-icon class="loader" v-if="$store.state.systems.status">mdi-sync</v-icon>
        <v-spacer></v-spacer>
        <v-img :src="system.game.url" style="position:absolute;top:0;right:0" height="100%" width="140px" gradient="to bottom, rgba(0,0,0,.1) 50%, rgba(0,0,0,.9)">
          <div style="position:absolute;top:0;right:3px;color:#DDD;font-size:15px;font-weight:bold">{{system.game.track.track_name}}</div>
          <div style="position:absolute;bottom:0;right:5px;">{{system.game.track.date | moment("Do MMMM")}} {{system.date | moment("HH:mm")}}</div>
        </v-img>
      </v-app-bar>

      <v-content style="overflow-x: scroll;flex-wrap: nowrap;display: flex;align-items: center;justify-content: center;padding-left:10px;padding-top:10px;padding-bottom:10px">
        <v-alert type="success" outlined>
          <h1>Aktiva regler</h1>
          <div v-if="system.reduction_rules.abcd_rule.use">
            <v-chip v-if="system.reduction_rules.abcd_a.use" style="margin:5px" outlined><span style="font-weight:bold;padding-right:5px">{{system.reduction_rules.abcd_a.prio}}-Hästar | </span> <span v-if="system.reduction_rules.abcd_a.min > 0" style="padding-right:5px">Minst {{system.reduction_rules.abcd_a.min}} - </span> <span> Max {{system.reduction_rules.abcd_a.max}}</span>
            </v-chip>
            <v-chip v-if="system.reduction_rules.abcd_b.use" style="margin:5px" outlined><span style="font-weight:bold;padding-right:5px">{{system.reduction_rules.abcd_b.prio}}-Hästar | </span> <span v-if="system.reduction_rules.abcd_b.min > 0" style="padding-right:5px">Minst {{system.reduction_rules.abcd_b.min}} - </span> <span> Max {{system.reduction_rules.abcd_b.max}}</span>
            </v-chip>
            <v-chip v-if="system.reduction_rules.abcd_c.use" style="margin:5px" outlined><span style="font-weight:bold;padding-right:5px">{{system.reduction_rules.abcd_c.prio}}-Hästar | </span> <span v-if="system.reduction_rules.abcd_c.min > 0" style="padding-right:5px">Minst {{system.reduction_rules.abcd_c.min}} - </span> <span> Max {{system.reduction_rules.abcd_c.max}}</span>
            </v-chip>
            <v-chip v-if="system.reduction_rules.abcd_d.use" style="margin:5px" outlined><span style="font-weight:bold;padding-right:5px">{{system.reduction_rules.abcd_d.prio}}-Hästar | </span> <span v-if="system.reduction_rules.abcd_d.min > 0" style="padding-right:5px">Minst {{system.reduction_rules.abcd_d.min}} - </span> <span> Max {{system.reduction_rules.abcd_d.max}}</span>
            </v-chip>
          </div>
          <div v-if="system.reduction_rules.own_rank.use">
            <v-chip v-if="system.reduction_rules.own_rank.use" style="margin:5px" outlined><span style="font-weight:bold;padding-right:5px">Egen ranksumma | </span> <span v-if="system.reduction_rules.own_rank.min > 0" style="padding-right:5px">Minst {{system.reduction_rules.own_rank.min}} - </span> <span> Max {{system.reduction_rules.own_rank.max}}</span>
            </v-chip>
          </div>
          <div v-if="system.reduction_rules.startnumber_sum.use">
            <v-chip v-if="system.reduction_rules.startnumber_sum.use" style="margin:5px" outlined><span style="font-weight:bold;padding-right:5px">Startnummersumma | </span> <span v-if="system.reduction_rules.startnumber_sum.min > 0" style="padding-right:5px">Minst {{system.reduction_rules.startnumber_sum.min}} - </span> <span> Max {{system.reduction_rules.startnumber_sum.max}}</span>
            </v-chip>
          </div>
          <div v-if="system.reduction_rules.points.use">
            <v-chip v-if="system.reduction_rules.points.use" style="margin:5px" outlined><span style="font-weight:bold;padding-right:5px"> Poängsumma | </span> <span v-if="system.reduction_rules.points.min > 0" style="padding-right:5px">Minst {{system.reduction_rules.points.min}} - </span> <span> Max {{system.reduction_rules.points.max}}</span>
            </v-chip>
          </div>
          <div v-if="system.reduction_rules.row_value.use">
            <v-chip v-if="system.reduction_rules.row_value.use" style="margin:5px" outlined><span style="font-weight:bold;padding-right:5px"> Radvärde | </span> <span v-if="system.reduction_rules.row_value.min > 0" style="padding-right:5px">Minst {{system.reduction_rules.row_value.min}}:-  </span> <span> Max {{system.reduction_rules.row_value.max}}:-</span>
            </v-chip>
          </div>
          <div v-for="group in system.reduction_rules.groups" :key="group.group">
            <v-chip v-if="group.use" style="margin:5px" outlined><span style="font-weight:bold;padding-right:5px"> Utgång {{group.group}} | </span> <span v-if="group.min > 0" style="padding-right:5px">Minst {{group.min}} - </span> <span> Max {{group.max}}</span>
            </v-chip>
          </div>
        </v-alert>
        <div v-if="!gameOver">
          <v-alert dense text type="success">Spelinformation uppdaterades: <strong>{{latestUpdate | moment("HH:mm")}}</strong> ({{latestUpdate | fromNow}})</v-alert>
        </div>
        <v-alert
          icon="mdi-check"
          prominent
          text
          type="success"
          v-if="gameOngoing"
        >
          Spelet pågår!
          <v-btn text dense dark color="primary" @click="showAllResults = true" v-if="!showAllResults && gameStarted">Visa resultat</v-btn>
        </v-alert>
        <v-alert
          icon="mdi-check-outline"
          prominent
          text
          :type="resultsBoxType"
          v-if="gameOver"
        >
          <h2>Spelet är slut!</h2>
          <v-btn text dense dark color="primary" @click="showAllResults = true" v-if="!showAllResults && gameOver">Visa resultat</v-btn>
          <div v-if="showAllResults">
            <span v-for="(resItem, index) in system.game_result.PayOutList" :key="`resItem-${index}`">
              <strong>Utdelning {{resItem.NumberOfCorrect}} rätt: {{resItem.PayOutAmount | numberSpacing}}:-</strong> ({{resItem.NumberOfSystems | numberSpacing}} system, totalt {{resItem.TotalAmount | numberSpacing}}:-)<br/></span><br/>
            <strong>Vinst: {{system.game_result.TotalWinnings}}:-</strong><br/> Antal korrekta rader: {{system.game_result.NumberOfWinningRows.toString().replace(/,/g, ' / ')}}
          </div>
        </v-alert>

        <!-- DISPLAY MENU FOR SYSTEM -->
        <v-menu :open-on-hover="false" offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn icon color="primary" dark v-on="on" >
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click.stop="layoutExpanded = !layoutExpanded">
              <v-list-item-action>
                <v-btn icon  v-if="userIsOwner">
                  <v-icon v-if="!layoutExpanded">mdi-arrow-expand</v-icon>
                  <v-icon v-if="layoutExpanded">mdi-arrow-collapse</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-title>
                <span v-if="!layoutExpanded">Visa samtliga lopp</span>
                <span v-if="layoutExpanded">Visa enskilda lopp</span>
              </v-list-item-title>
            </v-list-item>

            <v-subheader>Sortering</v-subheader>
              <v-list-item v-for="item in sortings" :key="item.value" @click="changeSorting(item.value)">
                <v-list-item-action>
                  <v-checkbox v-model="sorting" :value="item.value"></v-checkbox>
                </v-list-item-action>
                <v-list-item-title>{{item.text}}</v-list-item-title>
              </v-list-item>
          </v-list>
        </v-menu>

        <v-card v-if="!layoutExpanded" >
          <v-tabs v-model="raceTab" background-color="primary" dark>
            <v-tab v-for="race in system.game.race_list" :key="`tab-${race.leg_nr}`">{{system.code}}-{{race.leg_nr}}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="raceTab">
            <v-tab-item v-for="race in system.game.race_list" :key="`tab-${race.leg_nr}`">
              <Race :showAllResults="showAllResults" :system="system" :race="race" :key="race.leg_nr" :sorting="sorting" style="display:inline-block;vertical-align:top;margin-right:20px !important;"></Race>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row v-if="layoutExpanded">
            <Race :showAllResults="showAllResults" :system="system" v-for="race in system.game.race_list" :key="race.leg_nr" :race="race" :sorting="sorting"
              style=""></Race>
        </v-row>
      </v-content>
    </div>
  </div>

</template>
<style scoped>
.nav-value-box {
  text-align:center;
  margin-left: 10px;
  margin-right: 10px;
}
.nav-value-box .nav-value-box__title {
  font-size:12px;
  border-bottom:1px dashed #ddd;
  padding-bottom:3px;
}
.nav-value-box .nav-value-box__value {
  font-weight: bold;
}
.loader {
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(-360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(-360deg); }
}
</style>
<script>
import { mapActions } from 'vuex'
import Race from '@/components/Race.vue'
import SystemSettings from '@/components/SystemSettings.vue'

export default {
  data () {
    return {
      system: null,
      sorting: localStorage.getItem('sorting'),
      drawer: null,
      tab: null,
      raceTab: null,
      numberOfRaces: null,
      resultsBoxType: 'info',
      latestUpdate: new Date(),
      layoutExpanded: localStorage.getItem('layoutExpanded') || true,
      showAllResults: false,
      sortings: [
        {
          text: 'Startnummer',
          value: 'start_nr'
        },
        {
          text: 'Spelprocent',
          value: 'stake_distribution_share'
        },
        {
          text: 'Vinnarodds',
          value: 'odds'
        },
        {
          text: 'Egen ranking',
          value: 'own_rank',
          hint: 'Dra och släpp hästar för att rangordna'
        },
        {
          text: 'Valda hästar',
          value: 'selected'
        }
      ]
    }
  },
  components: {
    Race,
    SystemSettings
  },

  mounted () {
    const id = this.$router.currentRoute.params.id
    const that = this
    this.fetchSystemAction(id).then(function () {
      that.system = that.$store.state.systems.system
      that.numberOfRaces = that.system.game.race_list.length
      if (that.gameStarted && that.system.locked) {
        that.fetchResultsAction(that.system.id)
      }
      const gameDetails = { code: that.system.code, date: that.system.game.track.date, track_id: that.system.game.track.track_id }
      that.fetchLiveDataAction(gameDetails)
    })

    // Fetch data unless race is over
    if (window.pollingInterval !== undefined && window.pollingInterval !== 'undefined') {
      window.clearInterval(window.pollingInterval)
    }
    window.pollingInterval = window.setInterval(() => {
      console.log('polling data', this.system.id)
      if (this.gameOngoing && this.system.locked) {
        this.fetchResultsAction(this.system.id)
      }
      if (!this.system.locked) {
        // this.fetchReductionResultAction(this.system.id)
      }
      if (!this.gameOver) {
        // Should fetch a game, but instead updates the entire system as the system_horse has not been accounted for.
        const gameDetails = { code: this.system.code, date: this.system.game.track.date, track_id: this.system.game.track.track_id }
        this.fetchLiveDataAction(gameDetails)
      }
      if (!this.gameOver || !this.system.locked) {
        // this.fetchSystemAction(this.system.id)
      }
    }, 30000)
  },

  beforeRouteLeave (to, from, next) {
    if (window.pollingInterval !== undefined && window.pollingInterval !== 'undefined') {
      window.clearInterval(window.pollingInterval)
    }
    next()
  },

  methods: {
    ...mapActions(['fetchSystemAction', 'setRuleValuesAction', 'lockSystemAction', 'unlockSystemAction', 'fetchResultsAction', 'fetchReductionResultAction', 'fetchGameAction', 'updateCouponSettingsAction', 'updateReserveHandlingAction', 'fetchLiveDataAction']),
    changeSorting (value) {
      this.sorting = value
      localStorage.setItem('sorting', this.sorting)
    }

  },

  computed: {

    gameOver () {
      return !!this.system.game_result.ResultComplete
    },

    gameStarted () {
      return new Date() > new Date(this.system.date)
    },

    gameOngoing () {
      return this.gameStarted && !this.gameOver
    },

    userIsOwner () {
      const user = this.$store.state.user.user
      return user.id === this.system.user_id
    }

  }
}
</script>
